import React, { Suspense, useState } from 'react'
import { renderRoutes } from 'react-router-config'
import { Redirect } from 'react-router-dom'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/styles'
import { LinearProgress, useMediaQuery } from '@material-ui/core'
import NavBar from './NavBar'
import TopBar from './TopBar'
import ls from 'local-storage'
import usePermissions from 'src/utils/usePermissions'
import clsx from 'clsx'
import { useHistory } from 'react-router'
import configuration from '../../configuration'
import GoogleAnalytics from '../../components/GoogleAnalytics'
import Clarity from '../../components/Clarity'
import ScheduledMaintenanceBanner, {
  SCHEDULED_MAINTENANCE_BANNER_HEIGHT,
  SCHEDULED_MAINTENANCE_MOBILE_BANNER_HEIGHT
} from './ScheduledMaintenanceBanner'
import { useScheduledMaintenance } from './scheduledMaintenance'

const useStyles = makeStyles((theme) => ({
  container: {
    minHeight: '100vh',
    display: 'flex',
    '@media all and (-ms-high-contrast:none)': {
      height: 0 // IE11 fix
    }
  },
  content: {
    paddingTop: 64,
    flexGrow: 1,
    maxWidth: '100%',
    overflowX: 'hidden'
  },
  menuOpenContent: {
    [theme.breakpoints.up('md')]: {
      paddingLeft: '14.5vw',
      transition: 'padding-left .2s ease'
    },
    [theme.breakpoints.down('xs')]: {
      paddingTop: 56
    }
  },
  menuClosedContent: {
    [theme.breakpoints.up('md')]: {
      paddingLeft: 68,
      transition: 'padding-left .2s ease'
    },
    [theme.breakpoints.down('xs')]: {
      paddingTop: 56
    }
  },
  maintenanceContent: {
    paddingTop: 64 + SCHEDULED_MAINTENANCE_BANNER_HEIGHT,
    [theme.breakpoints.down('xs')]: {
      paddingTop: 56 + SCHEDULED_MAINTENANCE_MOBILE_BANNER_HEIGHT
    }
  }
}))

/* Layout per l'intera dashboard. Posso accederci solo se ho fatto login */
function Dashboard ({ route }) {
  const classes = useStyles()
  const [openNavBarMobile, setOpenNavBarMobile] = useState(false)
  const [isNavBarDesktopCollapsed, setIsNavBarDesktopCollapsed] = useState(false)
  const history = useHistory()
  const requestedLocation = history.location.pathname + history.location.search

  // Verifico i permessi e setto utente e token nel localstorage
  usePermissions()
  const user = ls.get('plsadv_user')
  const isSmall = useMediaQuery(theme => theme.breakpoints.down('sm'))
  const isExtraSmall = useMediaQuery(theme => theme.breakpoints.down('xs'))
  const isScheduledMaintenanceVisible = useScheduledMaintenance()
  const showScheduledMaintenance = Boolean(user) && isScheduledMaintenanceVisible
  const topOffset = isExtraSmall
    ? 56 + SCHEDULED_MAINTENANCE_MOBILE_BANNER_HEIGHT
    : 64 + SCHEDULED_MAINTENANCE_BANNER_HEIGHT
  const contentClassName = clsx(
    classes.content,
    showScheduledMaintenance && classes.maintenanceContent,
    !isSmall && !isNavBarDesktopCollapsed ? classes.menuOpenContent : classes.menuClosedContent
  )

  return (
    <>
      {configuration.environment === 'production' ? <GoogleAnalytics /> : null}
      {configuration.environment === 'production' ? <Clarity /> : null}
      {showScheduledMaintenance ? <ScheduledMaintenanceBanner /> : null}
      <TopBar
        hasScheduledMaintenance={showScheduledMaintenance}
        isNavBarDesktopCollapsed={isNavBarDesktopCollapsed}
        onToggleNavBarDesktop={() => setIsNavBarDesktopCollapsed((collapsed) => !collapsed)}
        onOpenNavBarMobile={() => setOpenNavBarMobile(true)}
      />
      <NavBar
        topOffset={showScheduledMaintenance ? topOffset : undefined}
        onMobileClose={() => setOpenNavBarMobile(false)}
        collapsedDesktop={isNavBarDesktopCollapsed}
        onToggleDesktop={setIsNavBarDesktopCollapsed}
        openMobile={openNavBarMobile}
        openDesktop
      />
      <div className={classes.container}>
        <div className={contentClassName}>
          <Suspense fallback={<LinearProgress />}>
            {user ? renderRoutes(route.routes) : <Redirect to={`/auth/login?requestedUrl=${requestedLocation}`} />}
          </Suspense>
        </div>
      </div>
    </>
  )
}

Dashboard.propTypes = {
  route: PropTypes.object
}

export default Dashboard
